import { Injectable } from '@angular/core';
import { throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, delay, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

class UserData {
  email: string;
  token: string;
  isAuth: boolean;
  accountType: number;
  orgId?: number;
  userType?: string;
  constructor(email: string, token: string, isAuth: boolean, accountType: number, orgId?: number, userType?: string) {
    this.email = email;
    this.token = token;
    this.isAuth = isAuth;
    this.accountType = accountType;
    this.orgId = orgId;
    this.userType = userType;
  }
}

class LoginReturnData {
  accountType: number;
  orgId: number;
  sessionKey: string;
  userType: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  userData = new BehaviorSubject<UserData>(null);

  constructor(private _http: HttpClient, private _router: Router) { }

  loginPost(email: string, password: string) {
    return this._http.post<LoginReturnData>(environment.serverUrl + 'account/login', { email, password })
      .pipe(delay(500), catchError(this.handleError),
        tap(resData => {
          this.handleAuthentication(email, resData);
        }));
  }

  public get currentUserDataValue(): UserData {
    return this.userData.value;
  }

  autoLogin() {
    const userData: {
      email: string;
      token: string;
      isAuth: boolean;
      accountType: number;
      orgId?: number;
      userType?: string;
    } = JSON.parse(localStorage.getItem('userData'));
    if (!userData) {
      return;
    }

    const loadedUser = new UserData(
      userData.email,
      userData.token,
      userData.isAuth,
      userData.accountType,
      userData.orgId,
      userData.userType,
    );
    if (loadedUser.token) {
      this.userData.next(loadedUser);
    }
  }

  logout() {
    this.userData.next(null);
    this._router.navigate(['/login']);
    localStorage.removeItem('userData');
  }

  private handleAuthentication(email: string, data: LoginReturnData) {
    const userData = new UserData(email, data.sessionKey, true, data.accountType, data.orgId, data.userType);
    localStorage.setItem('userData', JSON.stringify(userData));
    this.userData.next(userData);
  }

  private handleError(errorRes: HttpErrorResponse) {
    let errorMessage: string;
    switch (errorRes.status) {
      case 604:
        errorMessage = 'This Account is disabled';
        break;
      default:
        errorMessage = 'Username or Password are wrong';
        break;
    }
    console.log(errorRes);
    return throwError(errorMessage);
  }
}
